import React from 'react';
import NewTTSContainer from '@src/containers/TTSNew';

const TTS = () => <NewTTSContainer />;
export default TTS;
